module.exports = __webpack_public_path__ + "static/julys-people-1182202f05b44a71d73dac376c3f59c5.jpg";